import React from 'react';
import styled from 'styled-components';

export default function CourseSection() {
  let course_list_1 = [
    'Anatomy',
    'Biochemistry',
    'Physiology',
    'Microbiology',
    'Pathology',
    'Pharmacology',
    'Anesthesia',
    'Forensic Medicine',
    'Community Medicine',
    'Dermatology'
  ];
  let course_list_2 = [
    'Medicine',
    'Obsetrics',
    'Gyanacology',
    'Ophthalmology',
    'Orthopaedics',
    'ENT',
    'Pediatrics',
    'Psychiatry',
    'Surgery',
    'Radiology'
  ];

  return (
    <section className="courses-area section-gap" id="courses_block">
      <div className="container">
        <div className="text-center mb-70">
          <h1>Courses</h1>
        </div>
        <Grid grid={1}>
          <div className="text-center mb-70">
            <h3>NMCLE</h3>
            Nepal Medical Council Licensing Exam is the exam required to obtain
            the Registered Doctor License in Nepal. All MBBS passed students
            with atleast 6 months of rotary internship experience from any NMC
            recognised center can attend this licensing exam. These exams are
            carried out every 4 months resulting in 3 exams per year.
          </div>
        </Grid>

        <h4 style={{ textAlign: 'center', marginBottom: '15px' }}>
          NMCLE subjects
        </h4>
        <Grid grid={2}>
          <div className="courses">
            <ul className="courses-list">
              {course_list_1.map((course, index) => {
                return (
                  <li key={index}>
                    <p>
                      <svg
                        aria-hidden="true"
                        style={{ marginRight: '20px' }}
                        height="3%"
                        width="4%"
                        focusable="false"
                        data-prefix="fas"
                        data-icon="book"
                        className="svg-inline--fa fa-book fa-w-14"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                      >
                        <path
                          fill="currentColor"
                          d="M448 360V24c0-13.3-10.7-24-24-24H96C43 0 0 43 0 96v320c0 53 43 96 96 96h328c13.3 0 24-10.7 24-24v-16c0-7.5-3.5-14.3-8.9-18.7-4.2-15.4-4.2-59.3 0-74.7 5.4-4.3 8.9-11.1 8.9-18.6zM128 134c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm0 64c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm253.4 250H96c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32-32h285.4c-1.9 17.1-1.9 46.9 0 64z"
                        />
                      </svg>
                      {course}
                    </p>
                  </li>
                );
              })}
            </ul>
          </div>

          <div className="courses">
            <ul className="courses-list">
              {course_list_2.map((course, index) => {
                return (
                  <li key={index}>
                    <p>
                      <svg
                        aria-hidden="true"
                        style={{ marginRight: '20px' }}
                        height="3%"
                        width="4%"
                        focusable="false"
                        data-prefix="fas"
                        data-icon="book"
                        className="svg-inline--fa fa-book fa-w-14"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                      >
                        <path
                          fill="currentColor"
                          d="M448 360V24c0-13.3-10.7-24-24-24H96C43 0 0 43 0 96v320c0 53 43 96 96 96h328c13.3 0 24-10.7 24-24v-16c0-7.5-3.5-14.3-8.9-18.7-4.2-15.4-4.2-59.3 0-74.7 5.4-4.3 8.9-11.1 8.9-18.6zM128 134c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm0 64c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm253.4 250H96c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32-32h285.4c-1.9 17.1-1.9 46.9 0 64z"
                        />
                      </svg>
                      {course}
                    </p>
                  </li>
                );
              })}
            </ul>
          </div>
        </Grid>
      </div>
    </section>
  );
}

const Grid = styled.div`
  display: grid;
  grid-gap: 0 1em;
  grid-template-columns: repeat(${props => props.grid}, 1fr);
`;
